<template>
  <div
    class="h-screen"
    :style="
      clientStore.getCustomBackgroundImagePath !== null
        ? 'background-image: url(' +
          clientStore.getCustomBackgroundImagePath +
          '); '
        : ''
    "
    :class="{
      'custom-background-image':
        clientStore.getCustomBackgroundImagePath !== null,
    }"
  >
    <BackgroundBubbles
      v-if="clientStore.getCustomBackgroundImagePath === null"
    />
    <div
      class="m-auto h-screen max-w-7xl flex justify-center align-middle flex-col"
    >
      <div class="text-4xl text-white mx-auto mb-8">
        {{ $t("ssosbk.passwordreset.info.title") }}
      </div>
      <div v-if="!isSetNewPasswordStarted" class="text-xl font-bold mx-auto">
        {{ $t("ssosbk.passwordreset.info.text") }}
      </div>

      <div v-if="activationStatusError" class="flex items-center pr-3 mx-auto">
        <ExclamationCircleIcon
          class="h-5 w-5 text-red-800"
          aria-hidden="true"
        />
        <div class="text-xl text-red-800">
          {{ $t("ssosbk.passwordreset.error.text") }}
        </div>
      </div>

      <div class="text-xl mx-auto pt-44">
        <input
          v-if="!isSetNewPasswordStarted"
          v-model="resetMail"
          placeholder="Email-Adresse"
          required
          type="email"
          class="input-primary w-full"
        />
        <div
          v-if="!isSetNewPasswordStarted"
          class="cursor-pointer mt-2 w-full col-span-2 button-bkk-100 !text-background"
          @click="startResetPasswordProcess"
        >
          {{ $t("ssosbk.passwordreset.button.text") }}
        </div>
        <div v-else class="text-xl font-bold">
          {{ $t("ssosbk.passwordreset.success.text") }}
        </div>
      </div>
    </div>
    <FooterLinks bg-fixed />
  </div>
</template>

<script>
import BackgroundBubbles from "../../../components/v2/layout/BackgroundBubbles.vue";
import { startResetPassword } from "../../../api/sbk";
import { ExclamationCircleIcon } from "@heroicons/vue/solid";
import { useClientStore } from "../../../store/v2/client";
import FooterLinks from "../../../components/v2/sbk/FooterLinks.vue";
import { SBK_BLUE } from "../../../enum/v2/sbk";

export default {
  name: "ActivationPage",
  components: { FooterLinks, ExclamationCircleIcon, BackgroundBubbles },
  setup() {
    const clientStore = useClientStore();

    return {
      clientStore,
    };
  },
  data() {
    return {
      activationStatusError: null,
      isSetNewPasswordStarted: false,
      resetMail: null,
      client: null,
    };
  },
  async mounted() {
    if (
      this.clientStore.atmCampaign !== null &&
      this.clientStore.atmCampaign !== undefined
    ) {
      this.client = await this.clientStore.getClient(
        null,
        this.clientStore.atmCampaign
      );
    }

    this.clientStore.setClientColorsManually(
      SBK_BLUE,
      SBK_BLUE,
      SBK_BLUE,
      SBK_BLUE,
      SBK_BLUE
    );
  },
  methods: {
    startResetPasswordProcess() {
      if (!this.resetMail) {
        return;
      }

      this.isSetNewPasswordStarted = true;
      startResetPassword(this.resetMail);
    },
  },
};
</script>
